import React, { useState, useRef } from 'react';
import { CalculatorForm } from '../CalculatorForm';
import { ResultsDisplay } from '../ResultsDisplay';
import { ErrorBoundary } from '../ErrorBoundary';
import { CalculationResult } from '../../types';

interface CalculatorInstanceProps {
  index: number;
  onDelete?: () => void;
  onCalculate: (result: CalculationResult) => void;
  resultsRef?: React.RefObject<HTMLDivElement>;
  previousValues?: CalculationResult;
}

export function CalculatorInstance({
  index,
  onDelete,
  onCalculate,
  resultsRef,
  previousValues
}: CalculatorInstanceProps) {
  const [result, setResult] = useState<CalculationResult | null>(null);
  const calculatorRef = useRef<HTMLDivElement>(null);

  const handleCalculate = (calculationResult: CalculationResult) => {
    setResult(calculationResult);
    onCalculate(calculationResult);
  };

  return (
    <div className="space-y-4">
      <div ref={calculatorRef}>
        <ErrorBoundary>
          <CalculatorForm
            onCalculate={handleCalculate}
            onDelete={onDelete}
            formIndex={index}
            resultsRef={resultsRef}
            previousValues={previousValues}
          />
        </ErrorBoundary>
      </div>
      {result && (
        <div ref={resultsRef}>
          <ErrorBoundary>
            <ResultsDisplay
              result={result}
              calculatorRef={calculatorRef}
            />
          </ErrorBoundary>
        </div>
      )}
    </div>
  );
}